import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Nosidebar from './Nosidebar.vue'
import Default from './Default.vue'
import DefaultSlave from './DefaultSlave'
import VueSession from 'vue-session'
import store from './store'
import vuetify from './plugins/vuetify'
import excel from 'vue-excel-export'
import IdleVue from 'idle-vue'
import VueGeolocation from 'vue-browser-geolocation'
import browserDetect from 'vue-browser-detect-plugin'
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'
import GlobalSnackbar from './components/GlobalSnackbar.vue'

import '@babel/polyfill'
// Register a global custom directive called `v-role`
Vue.directive('role', { inserted: function (el, binding) {
  const fnc = require('./config/check-role')
  // passing parameter which is the role of logged user. the pr co,es from, directive
  fnc.check_role(binding.value)
}})


Vue.use(browserDetect)
Vue.use(VueGeolocation)
Vue.use(VueSession)
Vue.use(excel)
Vue.use(VueTour)
Vue.component('no-sidebar-layout', Nosidebar)
Vue.component('default-layout', Default)
Vue.component('GlobalSnackbar', GlobalSnackbar)
const eventsHub = new Vue()

//= =======Controla o tempo de actividade do usuário =======================================
Vue.use(IdleVue, {

  eventEmitter: eventsHub,
  idleTime: 1800000 // 30min
})

Vue.config.productionTip = true

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
